// src/routes/CrmRoutes.tsx
import { Route, Routes } from "react-router-dom";
import ContactsPage from '../pages/crm/contacts/ContactsPage';
import RequestsPage from '../pages/crm/requests/RequestsPage';
import RequestDetailPage from '../pages/crm/requests/RequestsDetailsPage';
import ContactCreatePage from '../pages/crm/contacts/ContactCreatePage';
import ContactDetailPage from '../pages/crm/contacts/ContactDetailPage';

export const CrmRoutes = () => {
    return (
        <Routes>
            <Route index element={<RequestsPage />} /> 
            <Route path="contacts" element={<ContactsPage />} />
            <Route path="requests" element={<RequestsPage />} />
            <Route path="requests/:requestId" element={<RequestDetailPage />} />
            <Route path="contacts/create" element={<ContactCreatePage />} />
            <Route path="contacts/:contactId" element={<ContactDetailPage />} />
        </Routes>
    );
};
